export function homeHero() {
  const homeHero = document.getElementById('home-hero');
  const heroVideo = document.querySelectorAll('.js-home-hero-video');
  //const dt = document.title
  if(heroVideo) {
    const init = () => {
      for(let i = 0; i < heroVideo.length; i++) {
        const target = heroVideo[i];
        const videoid = target.dataset.videoid;
        new YT.Player(target, {
          videoId: videoid,
          events: {
            'onReady': onPlayerReady
          },
          playerVars: {
            controls: 0, // 再生ボタン等
            showinfo: 0, // 動画名等
            fs: 0, // 全画面表示ボタン
            rel: 0, // 関連動画
            disablekb: 1, // ショートカットキー
            playsinline: 1, // インライン再生
            iv_load_policy: 3,
            modestbranding: 1,
            wmode: "opaque"
          }
        });
      }
    }
    const onPlayerReady = (event)=> {
      for(let i = 0; i < heroVideo.length; i++) {
        const target = heroVideo[i];
        const videoid = target.dataset.videoid;
        const cls = target.dataset.class;
        const et = event.target;
        let onTimer = ''

        if(et.getVideoData()['video_id'] == videoid) {
          const on = () => {
            onTimer = setTimeout(() => {
              if(!homeHero.classList.contains('is-image-active')) {
                et.playVideo();
                et.mute();
                //document.title = `Play: ${dt}`;
              }
            }, 300)
          }
          const off = () => {
            if(!homeHero.classList.contains('is-image-active')) {
              et.pauseVideo();
              et.seekTo(0,true);
              //document.title = `Pause: ${dt}`;
            }
          }

          on();

          const visibilitychangeShow = () => {
            const visibilitySet = document.visibilityState;
            if(visibilitySet == 'hidden') {
              clearInterval(onTimer);
              off();
            } else {
              on();
            }
          }
          document.addEventListener('visibilitychange', visibilitychangeShow);

          const timer = setInterval( () => {
            if(0 < et.getCurrentTime()) {
              clearInterval(timer);
              if(cls) {
                homeHero.classList.add(cls);
              } else {
                homeHero.classList.add('loaded');
              }
            }
          }, 50);

        }
      }
      
      const timer2 = setInterval( () => {
        let completeTimer = ''
        let onTimer = ''
        if(homeHero.classList.contains('home-hero-1') && homeHero.classList.contains('home-hero-2')) {
          clearInterval(timer2);
          const on = () => {
            onTimer = setTimeout(function(){
              homeHero.classList.add('is-video-active');
              completeTimer = setTimeout(() => {
                homeHero.classList.add('is-video-hide');
                homeHero.classList.add('is-image-active');
                //document.title = `${dt}`;
              }, 6000);
            }, 300)
          }
          const off = () => {
            homeHero.classList.remove('is-video-active');
          }

          on();

          const visibilitychangeShow = () => {
            const visibilitySet = document.visibilityState;
            if(visibilitySet == 'hidden') {
              clearInterval(onTimer);
              clearTimeout(completeTimer);
              if(!homeHero.classList.contains('is-image-active')) {
                off();
              }
            } else {
              if(!homeHero.classList.contains('is-video-active')) {
                on();
              }
            }
          }
          document.addEventListener('visibilitychange', visibilitychangeShow);
        }
      }, 50)
    }
    init();
  }
}